import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Image from "react-bootstrap/Image";
import Form from "react-bootstrap/Form";
import { TrashIcon, EditIcon, PlusIcon, UploadIcon } from "../../components/SVGIcon";
import { forEach } from "jszip";
import { Field } from "formik";
import { useAtomValue } from "jotai";
import { authAtom } from "../../states/auth";
import { DndContext, closestCenter } from "@dnd-kit/core";
import {
  SortableContext,
  arrayMove,
  rectSortingStrategy,
} from "@dnd-kit/sortable";
import SortablePhoto from "./SortablePhoto";
import { v4 as uuidv4 } from "uuid";

export const PhotoSectionSchema = {
  name: "Photos",
  tag: "Photos",
  fields: [
    {
      type: "arrayOfImages",
      name: "Photos",
      value: [
        { url: "", file: null, preview: null, text: "Placeholder" },
        { url: "", file: null, preview: null, text: "Placeholder" },
        { url: "", file: null, preview: null, text: "Placeholder" },
      ],
    },
  ],
};

const PhotoSection = ({
  // templateJson,
  // handleSectionNameChange,
  // isCreateReportRoute,
  // setTemplateJson,
  // section,
  // index,
  markSectionEditing,
  updateSection,
  templateId,
  templateType,
  conversationData,
  section,
  index,
  isCreateReportRoute
}) => {
  const [showModal, setShowModal] = useState(false);
  const [isEditModeOn, setIsEditModeOn] = useState(false);
  // const [fields, setFields] = useState([]);
  const [localSectionName, setLocalSectionName] = useState("");
  // LOCAL COPY
  const [localFields, setLocalFields] = useState([]);

  /* ---------------- EDIT MODE ---------------- */

  const handleEditStart = () => {
    setLocalSectionName(section?.name || "");
    setIsEditModeOn(true);

  };

  const exitEditMode = () => {
    setLocalSectionName(section?.name || "");
    setIsEditModeOn(false);
  };

  useEffect(() => {
    if (!section?.id) return;
    markSectionEditing(section.id, isEditModeOn);
  }, [isEditModeOn, section?.id, markSectionEditing]);

  const handleDeleteImage = (row, imageId) => {
    setLocalFields(prev => {
      const copy = structuredClone(prev);

      copy[row].value = copy[row].value.filter(
        img => img.id !== imageId
      );

      return copy;
    });
  };

  const emptyImage = () => ({
    id: uuidv4(),
    url: "",
    file: null,
    preview: null,
    text: "",
  });

  const handleClearImage = (row, imageId) => {
    setLocalFields(prev => {
      const copy = structuredClone(prev);
      const images = copy[row].value;

      // 1️⃣ Empty the selected image
      const cleared = images.map(img =>
        img.id === imageId
          ? { ...img, url: "", file: null, preview: null, text: "" }
          : img
      );

      // 2️⃣ Remove fully empty rows (groups of 3)
      const filtered = [];
      for (let i = 0; i < cleared.length; i += 3) {
        const chunk = cleared.slice(i, i + 3);

        const hasAnyImage = chunk.some(img => img.url);
        if (hasAnyImage) {
          filtered.push(...chunk);
        }
      }

      // 3️⃣ Normalize count to 3 / 6 / 9
      const count = Math.min(filtered.length, 9);
      const rounded = Math.ceil(count / 3) * 3;

      while (filtered.length < rounded) {
        filtered.push(emptyImage());
      }

      copy[row].value = filtered.slice(0, rounded);
      return copy;
    });
  };



  /* ---------------- INIT LOCAL STATE ---------------- */

  // const handleChange = (row, index, newText) => {
  //   setFields((prev) =>
  //     prev.map((field, i) => {
  //       if (i !== row) return field;

  //       const updatedValue = field.value.map((item, j) =>
  //         j === index ? { ...item, text: newText } : item
  //       );

  //       return { ...field, value: updatedValue };
  //     })
  //   );
  // };

  const handleChange = (row, index, newText) => {
    setLocalFields(prev => {
      const copy = [...prev];
      const field = { ...copy[row] };

      field.value = field.value.map((item, i) =>
        i === index ? { ...item, text: newText } : item
      );

      copy[row] = field;
      return copy;
    });
  };

  const handleDragEnd = (event, row) => {
    const { active, over } = event;

    if (!over || active.id === over.id) return;

    setLocalFields(prev => {
      const copy = structuredClone(prev);
      const images = copy[row].value;

      const oldIndex = images.findIndex(img => img.id === active.id);
      const newIndex = images.findIndex(img => img.id === over.id);

      copy[row].value = arrayMove(images, oldIndex, newIndex);
      return copy;
    });
  };


  console.log("Fieldsdoto ph", localFields)

  

  const handleDeleteSection = () => {
    updateSection(section.id, null); // parent removes it
    setShowModal(false);
  };

  // const handleImageUpload = (event, sectionId, fieldIndex, imageIndex) => {
  //   const file = event.target.files[0];
  //   if (!file) return;

  //   setTemplateJson((prev) => {
  //     const updated = { ...prev };

  //     // update schema.field value
  //     const sectionIdx = updated.schema.findIndex((s) => s.id === sectionId);
  //     if (sectionIdx === -1) return prev;

  //     const section = { ...updated.schema[sectionIdx] };
  //     const field = { ...section.fields[fieldIndex] };
  //     const newValue = [...(field.value || [])];

  //     newValue[imageIndex] = { file, preview: URL.createObjectURL(file), url: URL.createObjectURL(file), text: "" }; // new upload
  //     field.value = newValue;
  //     section.fields[fieldIndex] = field;
  //     updated.schema[sectionIdx] = section;

  //     // // update template-level images in same order
  //     // const templateImages = [...(updated.images || [])];
  //     // templateImages[imageIndex] = { file,  url: URL.createObjectURL(file), text: null, preview: URL.createObjectURL(file) };
  //     // updated.images = templateImages;

  //     return updated;
  //   });
  // };


  const handleImageUpload = (event, row, imageIndex) => {
    const file = event.target.files[0];
    if (!file) return;

    const preview = URL.createObjectURL(file);

    setLocalFields(prev =>
      prev.map((field, rIndex) => {
        if (rIndex !== row) return field;

        return {
          ...field,
          value: field.value.map((img, i) =>
            i === imageIndex
              ? { ...img, file, url: preview, preview, text: "" }
              : img
          )
        };
      })
    );
  };


  // CANCEL – discard local changes
  const handleCancel = () => {
    exitEditMode();
  };

  // SAVE TO templateJson
  // const handleSaveUpdate = () => {
  //   handleSectionNameChange(section.id, localSectionName);
  //   setIsEditModeOn(false);
  // };

  const handleSaveUpdate = () => {
    updateSection(section.id, prev => ({
      ...prev,
      name: localSectionName,
      fields: [...localFields],
    }));
    exitEditMode();
  };

  // useEffect(() => {
  //   const sectionData = templateJson?.schema?.find((s) => s.id === section?.id);
  //   setFields(sectionData?.fields ?? []);
  //   setLocalSectionName(section?.name || "");
  //   console.log("photoFields", sectionData?.fields)
  // }, [section]);

  const normalizeImages = (images, max = 9) => {
  const count = Math.min(images.length, max);
  const rounded = Math.ceil(count / 3) * 3;

  const normalized = [...images].slice(0, rounded);

  while (normalized.length < rounded) {
    normalized.push({
      id: uuidv4(),
      url: "",
      file: null,
      preview: null,
      text: "",
      
    });
  }

  return normalized;
};


  useEffect(() => {
    if (isEditModeOn) return;

    setLocalFields(
      structuredClone(section?.fields ?? []).map(field => ({
        ...field,
        value: normalizeImages(
          field.value.map(img => ({
            ...img,
            id: img.id ?? uuidv4(),
          }))
        ),
      }))
    );

    setLocalSectionName(section?.name || "");
  }, [section, isEditModeOn]);

  console.log("localFieldslocalFields", localFields)
  const auth = useAtomValue(authAtom);
  return (
    <>
      <div className="d-sm-flex align-items-sm-center justify-content-sm-between gap-3 p-3 border-bottom">
        {isEditModeOn ? (
          <Form.Control
            type="text"
            value={localSectionName}
            onChange={(e) => setLocalSectionName(e.target.value)}
            className="fs-20 fw-semibold mb-0 border-0 bg-transparent"
            style={{ maxWidth: "400px" }}
          />
        ) : (
          <Form.Control
            type="text"
            readOnly
            value={section?.name || ""}
            onChange={(e) => setLocalSectionName(e.target.value)}
            // onChange={(e) => handleSectionNameChange(section.id, e.target.value)}
            className="fs-20 fw-semibold mb-0 border-0 bg-transparent"
            style={{ maxWidth: "400px" }}
          />
        )}
        <div className="d-flex align-items-center gap-1 mt-3 mt-sm-0">
          {/* {!isEditModeOn && (
            <Button
              variant="icon"
              className="btn-md text-blue-600"
              onClick={() => setIsEditModeOn(true)}
            >
              <EditIcon />
            </Button>
          )} */}
          {/* <Button variant="icon" className="btn-md text-green-600">
              <CopyIcon />
            </Button> */}
          {(isCreateReportRoute && !isEditModeOn) && (
            <Button
              variant="icon"
              className="btn-md text-blue-600"
              onClick={() => setIsEditModeOn(true)}
            >
              {auth.user.roleId === 3 && <EditIcon />}
            </Button>
          )}
          {!isCreateReportRoute && <Button
            variant="icon"
            className="btn-md text-red-600"
            onClick={() => {
              setShowModal(true);
            }}
          >
            <TrashIcon />
          </Button>}
        </div>
      </div>
      <div className="p-3">
        <Row className="gx-3 gy-4">
          {localFields?.map((element, row) => {
            if (element.type !== "arrayOfImages") {
              return (
                <Col md="4" key={row}>
                  <picture className="ratio ratio-1x1 d-block mb-3">
                    <Image
                      className="rounded-3"
                      src="/images/image-placeholder.jpg"
                      width={150}
                      height={50}
                      alt="Header Image"
                    />
                  </picture>
                </Col>
              );
            }

            return (
              <DndContext
                key={row}
                collisionDetection={closestCenter}
                disabled
                onDragEnd={(e) => handleDragEnd(e, row)}
              >
                <SortableContext
                  items={element.value.map(img => img.id)}
                  disabled={!isEditModeOn && isCreateReportRoute}
                  strategy={rectSortingStrategy}
                >
                  
                  {element.value.map((photobject, index) => (
                    <Col md="4" key={photobject.id}>
                      <SortablePhoto key={photobject.id} id={photobject.id} disabled={isCreateReportRoute && !isEditModeOn} isEdited={isEditModeOn} imageURL={photobject.url} onDelete={() => handleClearImage(row, photobject.id)}>
                        <div 
                          className="report-photo-col border border-gray-200 rounded-3 ratio ratio-1x1 d-block mb-2 position-relative overflow-hidden"
                          style={{ '--bs-border-style': !photobject.url ? 'dashed' : 'solid'}}>
                          {isEditModeOn && <span className="photo-number-count">{index + 1}</span>}
                          {(isCreateReportRoute && isEditModeOn && !photobject.url) ? (
                            <>
                              <label
                              className="cursor-pointer d-flex align-items-center justify-content-center flex-column gap-3"
                              htmlFor={`photo-upload-${row}-${index}`}
                              >
                                <input
                                  hidden
                                  type="file"
                                  accept="image/*"
                                  id={`photo-upload-${row}-${index}`}
                                  onChange={(e) => handleImageUpload(e, row, index)}
                                />
                                <span className="rouded-button">
                                  <UploadIcon  className="text-blue-600" size="40" />
                                </span>
                                <span className="h3 fw-normal text-gray-500 mb-0">Upload Photo</span>
                              </label>
                            </>
                          ) : (
                            <>
                              <Image
                                className="object-fit-contain"
                                src={photobject.url || "/images/image-placeholder-white.jpg"}
                              />
                            </>
                          )}
                        </div>

                        {(isCreateReportRoute && isEditModeOn) && (
                          <textarea
                            className="form-control h-auto resize-none"
                            rows="3"
                            cols="3"
                            id={`photo-description-${row}-${index}`}
                            placeholder="Write your description here..."
                            value={photobject.text}
                            disabled={((isCreateReportRoute && !isEditModeOn) || (!isCreateReportRoute))}
                            onChange={(e) => handleChange(row, index, e.target.value)}
                            style={{ minHeight: '100%' }}
                          />
                        )}
                        
                      </SortablePhoto>
                      {(photobject.text && !isEditModeOn) &&  (
                        <>
                          <p className="fs-14 text-gray-500 mb-1">Description</p>
                          <p className="fs-16 text-gray-700 mb-0">{photobject.text}</p>
                        </>
                      )}
                    </Col>
                  ))}

                  {/* ADD ROW BUTTON */}
                  {isCreateReportRoute && isEditModeOn && element.value.length < 9 && (
                    <Col md="12">
                      <Button
                        className="w-100 border-0 bg-blue-100 text-blue-600 d-flex align-items-center justify-content-center gap-2"
                        onClick={() => {
                          setLocalFields(prev => {
                            const copy = structuredClone(prev);
                            copy[row].value.push(
                              { id: uuidv4(), url: "", text: "" },
                              { id: uuidv4(), url: "", text: "" },
                              { id: uuidv4(), url: "", text: "" }
                            );
                            return copy;
                          });
                        }}
                      >
                        <PlusIcon /> Add New Row
                      </Button>
                    </Col>
                  )}
                </SortableContext>
              </DndContext>
            );
          
          })}
        </Row>
      </div>

      {isEditModeOn && (
        <div className="p-3 border-top">
          <Row className="gy-2 gy-sm-0">
            <Col md="8" className="d-flex align-items-center gap-2">
              <Button variant="primary" className="btn-md" onClick={handleSaveUpdate}>
                Save & Update
              </Button>
              <Button variant="outline-secondary" className="btn-md" onClick={handleCancel}>
                Cancel
              </Button>
            </Col>
            {!isCreateReportRoute && (
              <Col md="4" className="text-sm-end">
                <Button variant="danger-light" className="btn-md" onClick={() => setShowModal(true)}>
                  Delete Section
                </Button>
              </Col>
            )}
          </Row>
        </div>
      )}

      <Modal
        className="info-modal"
        show={!!showModal}
        onHide={() => setShowModal(false)}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body>
          <div className="text-center">
            <Image src="/images/delete-badge-red.svg" alt="Delete Badge" />
            <h2 className="fs-2 fw-semibold text-gray-700 mt-5 mb-2">
              Are you sure you want to delete this section?
            </h2>

            <div className="d-flex align-items-center gap-3">
              <Button
                variant="primary"
                className="btn w-100 mt-5"
                onClick={handleDeleteSection}
              >
                Yes, Delete It!
              </Button>
              <Button
                variant="gray"
                className="btn w-100 mt-5"
                onClick={() => setShowModal(false)}
              >
                No, Not Yet
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PhotoSection;
